/* eslint-disable react/no-unescaped-entities */
import { Building2, Church, Trophy, GraduationCap, PartyPopper, Users } from 'lucide-react';
import { HOME } from '@/constants/testIds';

const SEGMENTS = [
  {
    icon: Building2,
    title: 'Small businesses',
    blurb: 'Branded staff tees, merch drops, launch giveaways — looking like a pro without the agency price tag.',
  },
  {
    icon: Church,
    title: 'Churches & ministries',
    blurb: 'Conference shirts, men\u2019s/women\u2019s ministry pieces, mission-trip tees and faith-driven designs.',
  },
  {
    icon: Trophy,
    title: 'Sports teams',
    blurb: 'Roster tees, warm-ups, fan gear, championship runs — uniformed without feeling like a uniform.',
  },
  {
    icon: GraduationCap,
    title: 'Schools',
    blurb: 'Class tees, club merch, fundraisers, spirit wear and end-of-year prints that students actually wear.',
  },
  {
    icon: PartyPopper,
    title: 'Events',
    blurb: 'Reunions, weddings, bachelor/bachelorette weekends, birthdays, festivals — make the day photogenic.',
  },
  {
    icon: Users,
    title: 'Families',
    blurb: 'Matching family tees, milestone shirts, memorials, holiday batches — keepsakes you\u2019ll actually keep.',
  },
];

const WhoWeServeSection = () => (
  <section
    id="who"
    data-testid={HOME.whoSection}
    className="relative bg-[#0a0a0a] text-white py-24 sm:py-28 px-6 sm:px-12 overflow-hidden"
  >
    {/* subtle accent dots */}
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.06] pointer-events-none"
      style={{
        backgroundImage:
          'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)',
        backgroundSize: '22px 22px',
      }}
    />

    <div className="relative max-w-6xl mx-auto">
      <div className="mb-12 sm:mb-14 max-w-2xl">
        <p className="font-body text-xs sm:text-sm tracking-[0.4em] uppercase text-brand-orange mb-3">
          Who we serve →
        </p>
        <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-[-0.02em] text-white">
          One studio. <br />
          <span className="text-brand-orange">A lot of people we love printing for.</span>
        </h2>
        <p className="font-body text-base text-white/70 mt-5">
          From one-of-one tees for a buddy to 200-piece bulk runs, we work with
          all kinds of clients. If your group has a story to tell, we can put it
          on a shirt.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {SEGMENTS.map(({ icon: Icon, title, blurb }) => (
          <div
            key={title}
            data-testid={`${HOME.whoCard}-${title.toLowerCase().replace(/\s+/g, '-')}`}
            className="group relative p-6 sm:p-7 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-brand-orange hover:bg-white/[0.05] transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-brand-orange text-black flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <Icon className="w-6 h-6" strokeWidth={2.25} aria-hidden="true" />
            </div>
            <div className="font-display font-black text-xl sm:text-2xl text-white leading-tight mb-2">
              {title}
            </div>
            <p className="font-body text-sm text-white/65 leading-relaxed">
              {blurb}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap items-center gap-4">
        <a
          href="#custom"
          className="inline-flex items-center gap-2 font-display font-bold text-sm uppercase tracking-wide bg-brand-orange text-black rounded-full px-6 py-3 hover:bg-white transition-colors"
        >
          Request a quote for your group →
        </a>
        <span className="font-body text-xs text-white/50 tracking-[0.2em] uppercase">
          Bulk pricing · proofs included
        </span>
      </div>
    </div>
  </section>
);

export default WhoWeServeSection;
